import { useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";
import { useSelector } from "react-redux";


const useCart = () => {
    const user = useSelector((state) => state.UserReducer.user);
    return useQuery(
        ['cart', user?.token],
        async () => {
            // This log will now fire every time a cart action succeeds
            // console.log(`REFETCHING CART for user: ${user?.token}`);
            const { data } = await axios.get(`${Config.apiUrl}/cart`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            // console.log('cart data >> ', data.data.cart);
            return data.data.cart;
        },
        {
            // The query will only run if we have a token
            enabled: !!user?.token,
        }
    );
};

export default useCart;